import BaseTable from "../table/BaseTable";
import LeadCard from "./LeadCard";
import Button from "../ui/Button";

import { useNavigate } from "react-router-dom";

import { SendHorizontal, View } from "lucide-react";

import { useId } from "react";

import { useLeadStore } from "../../store/leadStore";

import { useAuthStore } from "../../store/authStore";

export default function LeadsTable({ isMobile, leads, columns, handleResend }) {
  const { role } = useAuthStore();
  const { setSelectedLead } = useLeadStore();
  const navigate = useNavigate();
  const isAdmin = role === "admin";
  const id = useId();

  const handleLeadActivity = (lead) => {
    setSelectedLead(lead);
    navigate("/leads/activity");
  };
  if (isMobile) {
    return (
      <div className="leads-mobile-grid">
        {leads.map((lead, index) => (
          <LeadCard
            key={`${id}-${index}-lead-card`}
            lead={lead}
            handleResend={handleResend}
          />
        ))}
      </div>
    );
  }
  const expandedRowRender = (lead) => (
    <div className="lead-expanded">
      {/* 🔹 MINI LIST */}
      <div className="lead-row">
        <div>
          <span>Email:</span> {lead.email}
        </div>
        <div>
          <span>Timestamp:</span> {lead.timeline}
        </div>
        <div>
          <span>Conversation Time:</span> {lead.conversation_time}
        </div>
        <div>
          <span>Voice Duration:</span> {lead.voice_duration}
        </div>
        <div>
          <span>Primary Language:</span>{" "}
          {lead.language_monitoring?.primary_language}
        </div>
        {isAdmin && (
          <Button
            onClick={() => handleLeadActivity(lead)}
            className="gap-1 btn-md d-flex align-center justify-center"
            variant="secondary"
          >
            <View size={16} />
            View Activity
          </Button>
        )}
        <div className="lead-actions">
          {isAdmin && (
            <Button
              onClick={() => handleResend?.(lead)}
              className="gap-1 d-flex align-center justify-center"
            >
              <SendHorizontal size={16} />
              Resend Lead
            </Button>
          )}
        </div>
      </div>

      {/* 🔹 ACTION */}
    </div>
  );

  return (
    <BaseTable
      columns={columns}
      data={leads}
      rowKey="id"
      expandable={{ expandedRowRender }}
    />
  );
}
